import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';

export const invalidStatuses = [
  ChecklightSessionStatus.CANCELLED_CONSUMER,
  ChecklightSessionStatus.CANCELLED,
  ChecklightSessionStatus.DUPLICATE,
  ChecklightSessionStatus.EXPIRED,
  ChecklightSessionStatus.FUNDED,
];
